import { render, staticRenderFns } from "./Pacientes.vue?vue&type=template&id=472d54e2"
import script from "./Pacientes.vue?vue&type=script&lang=ts"
export * from "./Pacientes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports